<template>
  <v-dialog 
    v-model="dialog" 
    class="ch-dialog" 
    max-width="800"
  >
    <div class="ch-dialog-card">
      <v-toolbar class="ch-dialog-toolbar" :height="45">
        <v-toolbar-title>
          <i class="fas fa-flag fa-fw"></i>
          <span class="title">NEW DOMAIN</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <button @click="closeDialog" class="close-btn">
          <i class="fas fa-window-close fa-fw"></i>
        </button>
      </v-toolbar>
      <div class="ch-dialog-body">
        <v-form v-model="valid" ref="form">
          <v-layout row wrap>
            <v-flex xs6 class="pl-3 pr-3"><div class="form-group">
              <div class="form-title">NAME *</div>
                <div class="form-input">
                  <v-text-field
                    v-model="name"
                    :rules="nameRules"
                    full-width
                  ></v-text-field>
                </div>
              </div>
              <div class="form-group form-textarea-group">
                <div class="form-title">DESCRIPTION</div>
                <div class="form-input">
                  <v-text-field
                    v-model="desc"
                    full-width
                    textarea
                  ></v-text-field>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pl-3 pr-3">
              <div class="form-group">
                <div class="form-title">TYPE *</div>
                <div class="form-input">
                  <v-select
                    v-model="type"
                    :items="typeItems"
                    :rules="typeRules"
                    content-class="create-select"
                    full-width
                  ></v-select>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-form>
      </div>
      <div class="ch-dialog-footer">
        <button
          :class="{ save: valid }"
          :disabled="!valid"
          @click="createDomain"
        >
          <i class="fas fa-save fa-fw"></i>
          <span>SAVE</span>
        </button>
        <button
          class="cancel"
          @click="closeDialog"
        >
          <i class="fas fa-times-circle fa-fw"></i>
          <span>CANCEL</span>
        </button>
        <!-- <v-btn
          color="error"
          @click.native="clearAllField"
        >
          <v-icon class="mr-2">clear_all</v-icon>
          Clear All
        </v-btn> -->
      </div>
    </div>
  </v-dialog>
</template>

<script>
  import { domainsEventBus } from '@/components/admin/domains/domainsEventBus';
  import api from '../../../api';

  export default {
    data() {
      return {
        dialog: false,
        valid: true,
        id: null,
        name: null,
        desc: null,
        type: null,
        typeItems: ['root', 'normal'],
        created_at: null,
        updated_at: null,
        // NOTE: validation
        nameRules: [
          v => (v === 0) || !!v || 'Please input Name',
        ],
        typeRules: [
          v => (v === 0) || !!v || 'Please input Type',
        ],
      };
    },
    methods: {
      createDomain() {
        const params = {
          name: this.name,
          desc: this.desc,
          type: this.type,
        };
        api.createDomain(params)
        .then((result) => {
          if (result.status === 200) {
            this.alert.type = 'check_circle';
            this.alert.color = 'green';
            this.alert.message = 'Success Save';
            this.alertOccur();
            domainsEventBus.$emit('reloadList');
            this.closeDialog();
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      clearAllField() {
        this.$refs.form.reset();
      },
      /**
       * @description 전체 창 open, close
       */
      openDialog() {
        this.dialog = true;
      },
      closeDialog() {
        this.dialog = false;
        this.clearAllField();
      },
    },
    mounted() {
      domainsEventBus.$on('openDialog', () => {
        console.info('openDialog');
        this.openDialog();
      });
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/domains/CreateDomain.vue